import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, throwError } from 'rxjs';
import { ApiServiceService } from '../../../../services/api-service.service';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {

  refreshList = new BehaviorSubject<boolean>(false);
  closeDetails = new BehaviorSubject<boolean>(false);

  constructor(private apiService: ApiServiceService) { }

  getWeeks(page?: any) {
    return this.apiService.get(`${environment.apiUrl}/attendances/weeks${page ? `?page=${page}` : ''}`)
      .pipe(catchError(this.handleError));
  }

  getAllAttendances(filterModel: any): any {
    return this.apiService.get(`${environment.apiUrl}/attendances`, filterModel)
      .pipe(catchError(this.handleError));
  }

  updateAttendace(model: any) {
    return this.apiService.post(`${environment.apiUrl}/attendances/correct-check-in-check-out-time`, model)
      .pipe(catchError(this.handleError));
  }

  exportAttendancesAsExcel(model: any) {
    return this.apiService.getDownload(`${environment.apiUrl}/attendances/export-excel`, model)
      .pipe(catchError(this.handleError));
  }

  handleError(error: any) {
    return throwError(error);
  }
}